/* eslint-disable */
// Master definition of all feature categories and features.
// To add a new feature: add it here + set its default value in DEFAULT_PLANS.
// The admin UI and pricing page are generated automatically from this file.

export const PLAN_KEYS = ['free', 'starter', 'pro'];

export const FEATURE_CATEGORIES = [
  {
    key: 'navigationScreen',
    labels: { fr: 'Écran de navigation', en: 'Navigation screen', he: 'מסך ניווט' },
    features: [
      { key: 'imageList',   labels: { fr: 'Liste d\'images',   en: 'Image List',      he: 'רשימת תמונות' } },
      { key: 'missingWord', labels: { fr: 'Mot manquant',      en: 'Missing Word',    he: 'מילה חסרה'    } },
      { key: 'dynamicMap',  labels: { fr: 'Carte dynamique',   en: 'Dynamic Map',     he: 'מפה דינמית'   } },
      { key: 'carousel',    labels: { fr: 'Carrousel',         en: 'Carousel',        he: 'קרוסלה'       } },
    ],
  },
  {
    key: 'infoScreen',
    labels: { fr: "Écran d'information", en: 'Information screen', he: 'מסך מידע' },
    features: [
      { key: 'texte',  labels: { fr: 'Texte',               en: 'Text',              he: 'טקסט'           } },
      { key: 'audio',  labels: { fr: 'Audio',               en: 'Audio',             he: 'שמע'            } },
      { key: 'video',  labels: { fr: 'Vidéo (YouTube)',     en: 'Video (YouTube)',    he: 'וידאו (YouTube)' } },
      { key: 'ar',     labels: { fr: 'Réalité augmentée',  en: 'Augmented Reality', he: 'מציאות רבודה'   } },
      { key: 'phone',  labels: { fr: 'Appel simulé',       en: 'Simulated call',    he: 'שיחה מדומה'     } },
    ],
  },
  {
    key: 'settings',
    labels: { fr: '⚙️ Options du jeu', en: '⚙️ Game options', he: '⚙️ אפשרויות משחק' },
    features: [
      { key: 'bgImage',         labels: { fr: 'Image de fond',          en: 'Background image',    he: 'תמונת רקע'       } },
      { key: 'displayName',     labels: { fr: 'Nom d\'affichage',        en: 'Display name',        he: 'שם תצוגה'        } },
      { key: 'startLocation',   labels: { fr: 'Lieu de départ',         en: 'Start location',      he: 'מיקום התחלה'     } },
      { key: 'visitOrders',     labels: { fr: 'Ordres de visite',        en: 'Visit orders',        he: 'סדרי ביקור'      } },
      { key: 'fieldLink',       labels: { fr: 'Lien terrain',           en: 'Field link',          he: 'קישור שטח'       } },
    ],
  },
  {
    key: 'exercises',
    labels: { fr: 'Exercices', en: 'Exercises', he: 'תרגילים' },
    features: [
      { key: 'QCM',           labels: { fr: 'QCM',           en: 'Multiple Choice', he: 'בחירה מרובה'    } },
      { key: 'puzzle',        labels: { fr: 'Puzzle',        en: 'Puzzle',          he: 'פאזל'           } },
      { key: 'rushHour',      labels: { fr: 'Embouteillage', en: 'Traffic Jam',     he: 'פקק תנועה'      } },
      { key: 'trueFalse',     labels: { fr: 'Vrai ou Faux',  en: 'True or False',   he: 'נכון או לא נכון' } },
      { key: 'multipleMatch', labels: { fr: 'Association',   en: 'Multiple Match',  he: 'התאמה מרובה'    } },
      { key: 'memory',        labels: { fr: 'Mémory',        en: 'Memory',          he: 'זיכרון'         } },
      { key: 'signcard',      labels: { fr: 'Panneau',       en: 'Sign Card',       he: 'שלט'            } },
      { key: 'motManquant',   labels: { fr: 'Texte à trous', en: 'Fill in blanks',  he: 'השלמת טקסט'     } },
    ],
  },
];

export const DEFAULT_PLANS = {
  free: {
    label: 'Free',
    icon: '🪶',
    price: 0,
    currency: 'ILS',
    maxGames: 1,
    maxPoints: 8,
    features: {
      imageList: true,    missingWord: true,   dynamicMap: false,  carousel: false,
      texte: true,        audio: false,         video: false,       ar: false,    phone: false,
      QCM: true,          puzzle: false,        rushHour: false,
      trueFalse: false,   multipleMatch: false, memory: false,
      signcard: false,    motManquant: false,
      bgImage: false,     displayName: true,    startLocation: true,
      visitOrders: false, fieldLink: false,
    },
  },
  starter: {
    label: 'Plus',
    icon: '⭐',
    price: 29,
    currency: 'ILS',
    maxGames: 5,
    maxPoints: 20,
    features: {
      imageList: true,    missingWord: true,   dynamicMap: true,   carousel: true,
      texte: true,        audio: true,          video: true,        ar: false,    phone: false,
      QCM: true,          puzzle: false,        rushHour: false,
      trueFalse: true,    multipleMatch: true,  memory: true,
      signcard: false,    motManquant: true,
      bgImage: false,     displayName: true,    startLocation: true,
      visitOrders: true,  fieldLink: true,
    },
  },
  pro: {
    label: 'Premium',
    icon: '🏆',
    price: 79,
    currency: 'ILS',
    maxGames: 999,
    maxPoints: 999,
    features: {
      imageList: true,    missingWord: true,   dynamicMap: true,   carousel: true,
      texte: true,        audio: true,          video: true,        ar: true,     phone: true,
      QCM: true,          puzzle: true,         rushHour: true,
      trueFalse: true,    multipleMatch: true,  memory: true,
      signcard: true,     motManquant: true,
      bgImage: true,      displayName: true,    startLocation: true,
      visitOrders: true,  fieldLink: true,
    },
  },
};
